import { IonButton, IonActionSheet, IonIcon } from "@ionic/react";
import { isNativeIos } from "frontend-lib/Utils/Mobile";
import { reorderThreeOutline } from "ionicons/icons";
import React, { useMemo } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ChatItemActionsMobileProps {
    buttonsProps: Array<{
        key: string;
        action: string;
        permissions: any;
    }>;
    assignStatus: any;
    ownerStatus: any;
    adminStatus: any;
    actionCb: (action: string) => void;
}

export default function ChatItemActionsMobile({
    buttonsProps,
    assignStatus,
    ownerStatus,
    adminStatus,
    actionCb,
}: ChatItemActionsMobileProps) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const buttonsActionSheet = useMemo(() => {
        return buttonsProps
            .filter((data) => data)
            .filter(
                (data) =>
                    data.permissions && data.permissions[assignStatus][ownerStatus][adminStatus]
            )
            .map((data) => {
                return {
                    text: t("chatOptions." + data.action),
                    role: data.key === "close" ? "destructive" : undefined,
                    data: {
                        action: data.action,
                        actionCb: () => actionCb(data.action),
                    },
                };
            });
    }, [buttonsProps]);

    return (
        <>
            <IonButton
                id="open-action-sheet"
                fill="outline"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(true);
                }}
            >
                <IonIcon icon={reorderThreeOutline} />
            </IonButton>
            <IonActionSheet
                cssClass={isNativeIos() ? "optiwe-action-sheet" : ""}
                isOpen={isOpen}
                onDidDismiss={({ detail }) => {
                    detail.data?.actionCb();
                    setIsOpen(false);
                }}
                onClick={(e) => e.stopPropagation()}
                buttons={buttonsActionSheet}
            ></IonActionSheet>{" "}
        </>
    );
}
